module.exports = __webpack_public_path__ + "static/media/page-transitions.a2b73b5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page-transitions.mp4
// module id = 1Gmq
// module chunks = 1